import * as React from 'react';
import { Link } from 'react-router-dom';
import { ComponentsState, ErrorComponentsState, Menu, Notifications, SwitchErrorInfo, MenuItemProps } from 'piral';
import { Alert, Box, Snackbar, Stack, Typography} from '@mui/material';
import {Link as MuiLink} from '@mui/material';
import PortalDashboard from './dashboard';
import { useTheme } from '@mui/material/styles';
// @ts-ignore
import WilldanLogo from './assets/images/W_logo.png'; 
import Logo_liteBg from './assets/images/Logo_liteBg.png';

const MenuItem: React.FC<MenuItemProps> = ({ children }) => <li className="nav-item">{children}</li>;

const Footer = () => {
  
  return <footer style={{backgroundColor: useTheme().palette.background.info}}>
      <Box sx={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', paddingRight: '60px', paddingLeft: '60px',paddingTop: '20px', }}>
          
          <Box>
            <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
            <Stack>
              <Typography variant="body2" component="div" color="#000" style={{ textAlign: 'center' }}>
                Willdan Financial Services
              </Typography>
              <img src={Logo_liteBg} alt="Logo" style={{ width: '40px', marginRight: '10px', verticalAlign: 'text-bottom'}} />
            </Stack>
            </Link>
          </Box>
          <Box>
            <Typography variant="body1" component="div" color="#000" style={{ textAlign: 'center' }}>
              South Carolina | California | Maine
            </Typography>
          </Box>
          <Box>
            <MuiLink href="mailto:Admin@WilldanFinancialServices.com" sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body2" component="div" color="#000" style={{ textAlign: 'center' }}>
                Admin@WilldanFinancialServices.com
              </Typography>
            </MuiLink>
          </Box>
          <Box>
            <Stack>
              <MuiLink href="tel:1235555555" sx={{ display: 'flex',  alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                <Typography variant="body2" component="div" color="#000" style={{ textAlign: 'end' }}>
                  Support Line: (123) 555-5555
                </Typography>
              </MuiLink>
              <MuiLink href="tel:1235555555" sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                <Typography variant="body2" component="div" color="#000" style={{ textAlign: 'end' }}>
                  Toll Free: (123) 555-5555
                </Typography>
              </MuiLink>            
            </Stack>
          </Box>
        </Box>
      </Box>

      <Box sx={{height: '48px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        © 2025 Willdan Financial Services. All Rights Reserved.
      </Box>
</footer>
}

const defaultMenuItems = (
  <>
    <MenuItem type="general" meta={{}}>
      <Link className="nav-link text-dark" to="/">
        Home
      </Link>
    </MenuItem>
    <MenuItem type="general" meta={{}}>
      <Link className="nav-link text-dark" to="/property-search">
        Property Search 
      </Link>
    </MenuItem>
    <MenuItem type="general" meta={{}}>
      <Link className="nav-link text-dark" to="/about-us">
        About
      </Link>
    </MenuItem>
    <MenuItem type="general" meta={{}}>
      <Link className="nav-link text-dark" to="/faq">
        FAQ
      </Link>
    </MenuItem>
    <MenuItem type="general" meta={{}}>
      <Link className="nav-link text-dark" to="/services">
        Services
      </Link>
    </MenuItem>
    <MenuItem type="general" meta={{}}>
      <Link className="nav-link text-dark" to="/statutes">
        Statutes
      </Link>
    </MenuItem>
    <MenuItem type="general" meta={{}}>
      <Link className="nav-link text-dark" to="/contact-us">
        Contact
      </Link>
    </MenuItem>
  </>
);

export const errors: Partial<ErrorComponentsState> = {
  not_found: () => (
    <div>
      <p className="error">Could not find the requested page. Are you sure it exists?</p>
      <p>
        Go back <Link to="/">to the dashboard</Link>.
      </p>
    </div>
  ),
};

export const layout: Partial<ComponentsState> = {
  ErrorInfo: (props) => (
    <div>
      <h1>Error</h1>
      <SwitchErrorInfo {...props} />
    </div>
  ),
  DashboardContainer: PortalDashboard,
  DashboardTile: ({ columns, rows, children }) => <div className={`tile cols-${columns} rows-${rows}`}>{children}</div>,
  Layout: ({ children }) => (
    <div style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
      <Notifications /><Menu type="general" />
      <div style={{flexGrow: '1', display: 'flex'}}>{children}</div>
      <Footer/>
    </div>
  ),
  MenuContainer: ({ children }) => {
    const [collapsed, setCollapsed] = React.useState(true);
    return (
     <header style={{backgroundColor: useTheme().palette.background.info}}>
         <Box sx={{paddingLeft: '40px', paddingRight: '40px'}}>
          <nav className="navbar navbar-light navbar-expand-lg navbar-toggleable-lg ng-white mb-3" style={{padding: '0px'}}>
          <div className="container" style={{maxWidth: 'unset', padding: '0px'}}>
            <Link className="navbar-brand" to="/" style={{ display: 'flex', alignItems: 'center' }}>
            <img src={WilldanLogo} alt="Logo" style={{ width: '60px', marginRight: '10px', verticalAlign: 'text-bottom'}} />
              <Typography
                variant={'h1'}
                sx={{
                  fontWeight: '600',
                  display: 'flex',
                  justifyItems: 'flex-end',
                  justifyContent: 'flex-end',
                  marginBottom: '1',
                  textAlign: 'end',
                  color: useTheme().palette.info.main,
                  fontSize: 'max(1rem, min(4vw, 2rem))',
                  whiteSpace: 'nowrap'
                }}
              >Willdan Financial Services </Typography>
            </Link>
            <button
              aria-label="Toggle navigation"
              type="button"
              onClick={() => setCollapsed(!collapsed)}
              className="navbar-toggler mr-2">
              <span className="navbar-toggler-icon" />
            </button>
            <div
              className={`collapse navbar-collapse d-lg-inline-flex flex-lg-row-reverse ${collapsed ? '@media (max-width: 1199.98px)' : 'show'}`}
              aria-expanded={!collapsed}>
              <ul className="navbar-nav flex-grow">
                {defaultMenuItems}
                {children}
              </ul>
            </div>
          </div>
        </nav>
        </Box>
      </header>
      
    );
  },
  MenuItem,
  NotificationsHost: ({ children }) => <div className="notifications">{children}</div>,
  NotificationsToast: ({ options, onClose, children }) => (
    <Snackbar
      open
      autoHideDuration={options.autoClose}
      onClose={onClose}
    >
      <Alert
        severity={options.type}
        variant='filled'
        sx={{ width: '100%' }}
        onClose={onClose}
      >
        {children}
      </Alert>
    </Snackbar>
  ),
};
